// extracted by css-extract-rspack-plugin
export default {"createBranchLink":"NoBranchesOrLinkedPullRequests-module__createBranchLink__p0ytr"};